import React, {useState, useEffect, useContext, useRef} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import {useHistory, useLocation} from "react-router-dom";
// import QuizLiveAnswer from '../components/quiz-live-answer';

import { TimerImagePlaceholder, TimerHead } from '../svgs';
import { Field, Form, Formik } from 'formik';
import AnswerDefaultBox from '../../helpers/formik/answer-default';
import QuizLiveAnswer from '../quiz-live-answer';
import { EslidesEvent, Presentation } from '../../types/presentation';
import {gql, useQuery, useSubscription} from '@apollo/client';
import { Question } from '../../types/quiz';
import { InLinePreLoader } from '../preloader';
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import ScreenBottomBar from './screen-bottom-bar';
import SocketClient from '../../helpers/connection';
import EventContext from "../../contexts/event";
import { socketURL } from '../../helpers/constants';
import {presentation_by_pk, question_query, question_subscription, quiz_actions} from "../../gql/quiz-gql";
import {Socket} from "socket.io-client";
import axios from "axios";
import SproutVideo from "../sprout-video";
import SproutQuestionVideo from "../sprout-question-video";


const ScreenQuestions: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent; client:Socket}> = ({ locale, setLocale, ppt, event,client }) => {

  const [startTimer, setStartTimer] = useState(true);
  const [result, setResultPage] = useState(false);
  const [disableNext, setDisableNext] = useState(false);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [showTimer, setShowTimer] = useState(true);

  const history = useHistory();
  // @ts-ignore
  const [answeredUserCount, setAnsweredUserCount] = useState(parseInt(localStorage.getItem('answered_users')));
  // @ts-ignore
  const [connectedUserCount, setConnectedUserCount] = useState(parseInt(localStorage.getItem('connected_users')));
  const eventContext = useContext(EventContext);
  const location = useLocation();
  const stateData = location.state;
  const [secondData, setSecondData] = useState<{
    questions: Array<Question>;
  }>();
  const [actionData, setActionData] = useState({
    action: undefined,
    answered_count:undefined,
    id:undefined,
    presentation_id:undefined,
    question_index:undefined
  });
  const [optionData, setOptionData] = useState({
    action: undefined
  });

  const iframeRef = useRef(null);

  useEffect(() => {
    configSocket();
  }, []);

  // cache current_questions,current_questions_index in localStorage
  useEffect(() => {
    localStorage.setItem('current_questions',secondData?.questions[questionIndex].question??"");
    localStorage.setItem('current_questions_index',(questionIndex + 1)+"/"+secondData?.questions?.length);
  }, [questionIndex]);

  // configure socket connection and message handle
  function configSocket() {
    client.on('quiz-action-updates', function (data:any){
      setActionData(data);
      console.log('quiz-action-updates------ 1',data);
    });

    client.on('quiz-option-count-change', function (data:any){
      setOptionData(data);
      console.log('quiz-action-updates------ 1',data);
    });

    // sync actions with database using API
    axios
        .post(
            `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-user-action`,
            {
              _id: ppt._id,
            },
            {
            }
        ).then((res) => {
      console.log("check_quiz_action",res);
      // @ts-ignore
      console.log("back_press",res)
        setQuestionIndex(res.data.data.question_index);
        setResultPage(false);

    });
  }

  // sync actions with speaker using sockets message data
  useEffect(() => {
    if(actionData){
      let type= actionData.action;
      let index= actionData.question_index;
      // check type is timer_start
      if (type === 'timer_start') {

        setShowTimer(true);
        setStartTimer(true);
      } else if (type === 'timer_stop') {  // check type is timer_stop
        setStartTimer(false);
      } else if (type === 'timer_end') { // check type is timer_end
        setShowTimer(false);

      } else if (type === 'show_result') {  // check type is show_result
        setResultPage(true);
      } else if (type === 'next_question') { // check type is next_question
        localStorage.setItem('answered_users','0');
        setResultPage(false);
        nextQuestionEvent(index);
        setAnsweredUserCount(0);
        setShowTimer(true);

      } else if (type === 'show_podium') { // check type is show_podium
        history.push(
            `/${eventContext.slug}/${ppt._id}/screen-podium/${secondData?.questions[questionIndex]?.id??""}`,{'index':questionIndex}
        )
      }
      console.log("EVENT_CHANGE",actionData.action)
    }
  }, [actionData]);


  // handle answer count  select/deselect from attendee
  useEffect(() => {
    if(optionData){
      let type= optionData.action;
      // check action type is answer_count_in
      if (type === 'answer_count_in') {
        localStorage.setItem('answered_users',`${answeredUserCount+1}`);
        setAnsweredUserCount(answeredUserCount+1);
      } else if (type === 'answer_count_out') { // check action type is answer_count_out
        if(answeredUserCount>0) {
          localStorage.setItem('answered_users',`${answeredUserCount-1}`);
          setAnsweredUserCount(answeredUserCount - 1);

        }
      }
    }
  }, [optionData]);

  // update questionIndex while back from another page
  useEffect(() => {
    var data = location.state;

    // @ts-ignore
    if(data?.data === "back_press"){
      setShowTimer(false);
      console.log("back_press",data)
      history.replace({ ...location, state: undefined });
    }else {
      //setShowTimer(true);
    }

  }, [location.state]);


  const formRef = React.useRef<any>();

  // update question index when next_question action triggering time
  const nextQuestionEvent = (index: any) => {
    setStartTimer(true);
    setQuestionIndex(index);
  }

  // getting the presentation  data from back end
  const { data: firstData, loading: firstLoading, error: firstError } = useQuery(presentation_by_pk, {
    variables: {
      id: ppt && ppt._id
    },

    skip: !ppt
  },)
  // getting the presentation questions  details from back end
  const { data: secondQueryData, loading: secondLoading, error: secondError } = useSubscription<{
    questions: Array<Question>;

  }>(question_subscription, {
    variables: {
      presentation_id: ppt._id,
    },
    skip: !ppt,

  });

  // set quiz question data
  useEffect(() => {
    setSecondData(secondQueryData)
  }, [secondQueryData]);

// cache current_questions,current_questions_index in localstorage
  if(secondData && secondData.questions.length>0){
    localStorage.setItem('current_questions',secondData?.questions[questionIndex]?.question??"");
    localStorage.setItem('current_questions_index',(questionIndex + 1)+"/"+secondData?.questions?.length);
  }


  // quiz timer counting event
  const renderTime = ({ remainingTime }: { remainingTime: any }) => {

    if (remainingTime === 1) {
      setStartTimer(false)
    }

    if (remainingTime === firstData?.presentation_by_pk.timer) {
      if (questionIndex !== (secondData?.questions.length ?? 0) - 1) {
        setDisableNext(false);
      }
    } else {
      setDisableNext(true);
    }

    return (
      <div className="timer">
        <div className="value">{remainingTime}s</div>
      </div>
    );
  };

  // calculate answer count for each options
  function getAnswerCount(id: string | undefined) {
    let point = 0;
    if(secondData){
      for (let i = 0; i < secondData.questions[questionIndex].responses.length; i++) {
        for (let j = 0; j < secondData.questions[questionIndex].responses[i].options.length; j++) {
          if(secondData.questions[questionIndex].responses[i].options[j].question_option_id === id){
            point = point+1;
          }
        }
      }
    }
    return point;
  }
  return (
    <div className="quiz-live-screen-container">
      <div className="grid">
        <div className="timer-with-question" style={{ alignItems: 'unset' }}>
          <div className="event-details">
            <Row className="align-items-center">
              <Col md={2}> {event?.logo ?
                <img
                  height={90}
                  src={getEncodedImageUrl(event.logo, 110, 110, "contain")}
                  alt="logo"
                /> : <img height={45} src="/images/logo-default.png" alt="" />
              }  </Col>
              <Col></Col>
              <Col md={6}><h5>{ppt.name}</h5></Col>
            </Row>
          </div>
          <div className="timer-image-container"  style={{textAlign:secondData?.questions[questionIndex].active_media ==="video" ? "unset":"center"}}>
            <div className="image-placeholder">

              {
                /*show question image and question */
                secondData && secondData.questions.length > 0 && (secondData.questions[questionIndex].image && (secondData.questions[questionIndex].image !== undefined && secondData.questions[questionIndex].image !== "") || secondData?.questions[questionIndex].active_media ==="video")?
                    <div style={{width: secondData?.questions[questionIndex].active_media ==="video" ? 325: 220,height:220}}>
                      {
                        secondData?.questions[questionIndex].active_media ==="video" ? <div className='question-image' style={{height:'241px',width:'420px'}}>
                          {/*quiz question video components */}
                          <SproutQuestionVideo
                              id={secondData.questions[questionIndex].video_id!}
                              security_token={secondData?.questions[questionIndex].video_token}
                              skip={0}
                              className="video-modal-content-first"
                              volume={1}
                              ref={iframeRef}
                              autoPlay={true}
                              showcontrols={false}
                          />

                        </div> :<img className='question-image' src={getEncodedImageUrl(secondData.questions[questionIndex].image)} alt="Question"/>

                      }
                    </div> : <TimerImagePlaceholder/>
              }
              {firstData && (
                  <>
                    {showTimer ?
                        <div className="countdown-container">
                          <TimerHead/>
                          <CountdownCircleTimer
                              isPlaying={startTimer}
                              duration={firstData?.presentation_by_pk.timer ?? 0}
                              size={101}
                              strokeWidth={10}
                              strokeLinecap="square"
                              trailColor="transparent"
                              colors={[
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                              ]}
                              onComplete={() => {
                                return [true, 1000];
                              }
                              }
                          >
                            {renderTime}
                          </CountdownCircleTimer>
                        </div>

                        :
                        <div className="countdown-container">
                          <TimerHead/>
                          <CountdownCircleTimer
                              isPlaying={false}
                              duration={0}
                              size={101}
                              strokeWidth={0}
                              strokeLinecap="square"
                              trailColor="transparent"
                              colors={[
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                                ['#d7d8d9', 0.33],
                              ]}
                              onComplete={() => [false, 1000]}
                          >
                            {<div className="timer">
                              <div className="value">0s</div>
                            </div>}
                          </CountdownCircleTimer>
                        </div>}

                  </>


              )}
            </div>
            <h5 style={{paddingTop:'30px', textAlign:secondData?.questions[questionIndex].active_media ==="video"? "center":"unset"}}>question {questionIndex + 1}/{secondData?.questions.length}</h5>
            <p style={{textAlign:secondData?.questions[questionIndex].active_media ==="video"? "center":"unset"}}>{secondData?.questions[questionIndex]?.question ?? ""}</p>
          </div>
          <div>
            <span>Powered by</span>
            <img src="/images/e-slides-logo.png" alt="e-slides-logo" />
          </div>
        </div>
        <div className="answers-main">

          {secondLoading || !secondData ? (
            <div className='container'>
              <div className='row'>
                <Col>
                  <div className="quiz-live-answers-container" style={{justifyContent:'center',display:'flex'}}>
                    <InLinePreLoader />
                  </div>
                </Col>
                <div>
                </div>
              </div>
            </div>

          ) : (
            !result ?
              <div className='container'>
                <div className='row'>
                  <Col>
                    <div className="quiz-live-answers-container " >
                      <Formik
                        innerRef={formRef}
                        onSubmit={values =>  console.log(values)}
                        initialValues={{}}
                      >
                        {({ values }) => {
                          // const padclass = answers.length > 4 ? answers.length > 6 ? 'padClassMax' : 'padClassActive' : '';
                          const padclass = ''
                          if (secondData.questions[questionIndex].options.length <= 4) {
                            return (
                              <Form>
                                {
                                  secondData.questions[questionIndex].options.map((answer, i) => (
                                    <Field
                                      key={`answer#${answer.id}`}
                                      component={AnswerDefaultBox}
                                      alphabet={String.fromCharCode(i + 97)}
                                      name={`answer#${answer.id}`}
                                      id={`answer#${answer.id}`}
                                      padclass={`padClassActive`}
                                      label={answer.option}
                                    />
                                  ))
                                }
                              </Form>
                            )
                          } else if (secondData.questions[questionIndex].options.length <= 6) {
                            var code = 96;
                            return (
                              <Form>
                                <div className='container-fluid overflow-hidden'>
                                  <div className="row ">
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(0, 3).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={`padClassMax`}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(3, 6).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={`padClassMax`}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                  </div>

                                </div>
                              </Form>
                            )

                          }

                          else if (secondData.questions[questionIndex].options.length <= 8) {
                            var code = 96;
                            return (
                              <Form>
                                <div className='container-fluid overflow-hidden'>
                                  <div className="row ">
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(0, 4).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={'padClass20'}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(4, 8).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={'padClass20'}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                  </div>

                                </div>
                              </Form>
                            )
                          }
                          else {
                            var code = 96;
                            return (
                              <Form>
                                <div className='container-fluid overflow-hidden'>
                                  <div className="row ">
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(0, 5).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={padclass}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                    <div className="col ">
                                      {
                                        secondData.questions[questionIndex].options.slice(5, secondData.questions[questionIndex].options.length).map((answer, i) => (

                                          <Field
                                            key={`answer#${answer.id}`}
                                            component={AnswerDefaultBox}
                                            alphabet={String.fromCharCode(++code)}
                                            name={`answer#${answer.id}`}
                                            id={`answer#${answer.id}`}
                                            padclass={padclass}
                                            label={answer.option}
                                          />
                                        ))
                                      }
                                    </div>
                                  </div>

                                </div>
                              </Form>
                            )


                          }
                        }}
                      </Formik>
                    </div>
                  </Col>
                </div>
              </div> : <></>
            )
          }

          {result && secondData && <Container fluid>
            <Row>
              <Col>
                <div className="quiz-live-answers-container m-t-60">
                  <h5 style={{ color: 'white' }}>Question {questionIndex + 1}/{secondData?.questions.length}</h5>
                  <p className="q" style={{ color: 'white' }}>{secondData?.questions[questionIndex].question}</p>
                  {
                    secondData.questions[questionIndex].options.map((answer, index) => (
                      <QuizLiveAnswer
                        totalAnswersAggregate={123}
                        answerLength={secondData.questions[questionIndex].options.length}
                        key={answer.id}
                        alphabet={String.fromCharCode(index + 97)}
                        answer={answer.option}
                        totalAnswers={getAnswerCount(answer.id)}
                        value={answer.correct}
                      />
                    ))
                  }
                </div>
              </Col>
            </Row>
          </Container>
          }
        </div>
      </div>
      <ScreenBottomBar usersLength={connectedUserCount} presentationId={ppt._id} answersLength={answeredUserCount} />
    </div>
  )
}

export default ScreenQuestions;

// <ScreenBottmBar usersLength={200} presentationId={ppt._id} answersLength={50} />
